'use client';

import cx from 'classnames';
import { useAtomValue } from 'jotai';

import ChevronRightIcon from '@flipster/ui/assets/svgs/chevron-right.svg';

import styles from './index.module.scss';
import { glossaryTermAtom } from '../jotai';

const Breadcrumb = ({ className }: { className?: string }) => {
  const glossaryTerm = useAtomValue(glossaryTermAtom);
  if (!glossaryTerm) return;

  return (
    <nav aria-label='Breadcrumb' className={cx(styles.nav, className)}>
      <ul>
        <li>
          <a href='/'>Home</a>
        </li>
        <li>
          <ChevronRightIcon />
        </li>
        <li>
          <a href='/glossary'>Glossary</a>
        </li>
        <li>
          <ChevronRightIcon />
        </li>
        <li>{glossaryTerm.name}</li>
      </ul>
    </nav>
  );
};

export default Breadcrumb;
